var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.35 23.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #515251;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.14,2.45H1.21C.55,2.45,0,1.9,0,1.24S.55,.03,1.21,.03h14.93c.66,0,1.21,.54,1.21,1.21s-.54,1.21-1.21,1.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.14,8.49H1.21C.55,8.49,0,7.95,0,7.28s.54-1.21,1.21-1.21h14.93c.66,0,1.21,.54,1.21,1.21s-.54,1.21-1.21,1.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.59,13.54H1.21C.55,13.54,0,12.99,0,12.33s.54-1.21,1.21-1.21H5.59c2.39,0,4.35-1.93,4.35-4.35s-1.93-4.35-4.35-4.35H1.21C.55,2.42,0,1.87,0,1.21S.55,0,1.21,0H5.59c3.72,0,6.77,3.02,6.77,6.77s-3.02,6.77-6.77,6.77h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.03,23.96c-.3,0-.6-.12-.85-.33L.37,13.2c-.48-.45-.48-1.24-.03-1.72,.45-.48,1.24-.48,1.72-.03l10.82,10.39c.48,.45,.48,1.24,.03,1.72-.27,.24-.57,.39-.88,.39h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/Transactions.2b7d1ccfac49e131fa7a7a394a9a5875.svg";
export { ForwardRef as ReactComponent };